module.exports = __webpack_public_path__ + "static/media/profile-1.b8d07672.png";